<template>
  <b-container fluid>
    <FormulateForm
      name="createProductGroup"
      @submit="submitHandler"
      #default="{ isLoading }"
      v-model="formValues"
      data-cy="create-product-group-form"
    >
      <b-row>
        <b-col lg="6" offset-lg="3">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">Product group</h4>
            </template>
            <template v-slot:body>
              <b-form-row>
                <b-col>
                  <b-form-group label="Name" label-for="name">
                    <FormulateInput
                      id="name"
                      name="name"
                      type="text"
                      input-class="form-control"
                      data-cy="name-input"
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group label="Description" label-for="description">
                    <FormulateInput
                      id="description"
                      name="description"
                      type="textarea"
                      input-class="form-control"
                      data-cy="description-input"
                      rows="10"
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>
            </template>
          </iq-card>
        </b-col>
        <b-col lg="2" offset-lg="3">
          <router-link to="/product-groups">
            <b-button block variant="outline-primary" class="mb-3 mr-1"
              >Back to product groups</b-button
            >
          </router-link>
        </b-col>
        <b-col lg="4">
          <b-button
            block
            type="submit"
            variant="primary"
            class="mb-3 mr-1"
            data-cy="submit-button"
            :disabled="isLoading"
            :label="isLoading ? 'Loading...' : 'Submit this form'"
            >Save product group</b-button
          >
        </b-col>
      </b-row>
    </FormulateForm>
  </b-container>
</template>

<script>
import { core } from "../../config/pluginInit";
import gql from "graphql-tag";
const CREATE_PRODUCT_GROUP = gql`
  mutation createProductGroup($name: String, $description: String) {
    insert_product_groups_one(object: {
      name: $name,
      description: $description
    }) {
      id
      name
    }
  }
`;

export default {
  name: "ProductGroupsCreate",
  data() {
    return {
      formValues: {}
    };
  },
  methods: {
    async submitHandler() {
      try {
        await this.$apollo.mutate({
          mutation: CREATE_PRODUCT_GROUP,
          variables: {
            name: this.formValues.name,
            description: this.formValues.description ?? undefined
          }
        });
        this.$toast.success(`Product group saved`);
        this.$formulate.reset("createProductGroup");
      } catch (error) {
        this.$toast.error(`Failed to save product group: ${error.message}`);
      }
    }
  },
  mounted() {
    core.index();
  }
};
</script>
